import {
  TICKETS_SET_TICKETS,
  TICKETS_SET_SEARCH_STRING,
  TICKETS_TOGGLE_LOADING,
  TICKETS_TOGGLE_NEW_TICKET_DROPDOWN,
  TicketsActionTypes,
  ITicketsState,
  TICKETS_RESET_STORE,
  TICKETS_TOGGLE_FILTER_DROPDOWN,
  TICKETS_SET_FILTER_STRING,
  TICKETS_ADD_TICKET_TO_TICKETS, TICKETS_ESCALATE_TICKET,
} from './types';

const initialState: ITicketsState = {
  loading: false,
  openNewTicketDropdown: false,
  openFilterTicketsDropdown: false,
  tickets: [],
  searchString: '',
  visibleState: 'Active',
};

export function ticketsReducer(state = initialState, action: TicketsActionTypes) {

  switch (action.type) {
    case TICKETS_ADD_TICKET_TO_TICKETS:
      return {
        ...state,
        tickets: [action.theTicket, ...state.tickets],
      };
    case TICKETS_SET_TICKETS:
      return {
        ...state,
        tickets: action.tickets,
      };
    case TICKETS_SET_SEARCH_STRING:
      return {
        ...state,
        searchString: action.search,
      };
    case TICKETS_SET_FILTER_STRING:
      return {
        ...state,
        visibleState: action.payload,
      };
    case TICKETS_TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    case TICKETS_TOGGLE_NEW_TICKET_DROPDOWN:
      return {
        ...state,
        openNewTicketDropdown: !state.openNewTicketDropdown,
      };
    case TICKETS_TOGGLE_FILTER_DROPDOWN:
      return {
        ...state,
        openFilterTicketsDropdown: !state.openFilterTicketsDropdown,
      };
    case TICKETS_RESET_STORE:
      return {
        ...initialState,
      };

    case TICKETS_ESCALATE_TICKET:
      const ticketsEscalation = state.tickets.map((theTicket) => {

        if (theTicket.id === action.id) {

          theTicket.escalationState = 'Escalated';

        }
        return theTicket;

      });
      return {
        ...state,
        tickets: [...ticketsEscalation],
      };
    default:
      return {
        ...state,
      };
  }

}
